import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=0c03c86a&"
import script from "./NavigationFooter.vue?vue&type=script&lang=js&"
export * from "./NavigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports